import { Key } from "react";

/**
 * Per-deal Ignore for "New Lumen result" badges (spec §04, drawn defaults):
 * ignoring clears the badge; the run stays in Lumen's history. Stored per
 * browser (the Vero1RereviewBand dismissal pattern) keyed by the run id, so
 * a NEWER run re-raises the badge on the same row automatically.
 */
const ignoreKey = (
  dealId: Key,
  criterionKey: string,
  applicationId: Key | null
) =>
  `vero1-lumen-result-ignored:${dealId}:${criterionKey}:${
    applicationId ?? "deal"
  }`;

export const readIgnoredRun = (
  dealId: Key,
  criterionKey: string,
  applicationId: Key | null
): string | null => {
  try {
    return window.localStorage.getItem(
      ignoreKey(dealId, criterionKey, applicationId)
    );
  } catch {
    return null;
  }
};

export const storeIgnoredRun = (
  dealId: Key,
  criterionKey: string,
  applicationId: Key | null,
  runId: string
) => {
  try {
    window.localStorage.setItem(
      ignoreKey(dealId, criterionKey, applicationId),
      runId
    );
  } catch {
    // private mode: the ignore just won't survive a reload
  }
};
